import { render, staticRenderFns } from "./FormGroupSelect.vue?vue&type=template&id=3123668e"
import script from "./FormGroupSelect.vue?vue&type=script&lang=js"
export * from "./FormGroupSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports